<template>
    <div class="hl-tags-form">
        <tag
          :label="model.name"
          :color-important="model.color"
          :text-color-important="model.text_color"
        ></tag>
        <v-text-field
                :label="$t('msg.name')"
                v-model="model.name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
                v-validate="'required|max:255'"
                dense
                outlined
                hide-details="auto"
                class="card-form__input mt-3"
        ></v-text-field>
        <div class="d-flex flex-wrap">
          <input-color
            v-model="model.color"
            data-vv-name="name"
            :error-messages="errors.collect('name')"
            class="mt-3 mr-4"
          ></input-color>
          <input-color
            v-model="model.text_color"
            data-vv-name="name"
            :error-messages="errors.collect('name')"
            class="mt-3"
            label="msg.textColor"
          ></input-color>
        </div>
        <div class="d-flex justify-end mt-3">
            <v-btn
                    v-if="!isNew"
                    small
                    color="secondary"
                    class="mr-3 v-btn__light"
                    @click="deleteModel()"
                    :loading="loadingDelete"
                    dark
                    elevation="0"
            >{{ $t('msg.delete') }}</v-btn>
            <v-btn
                    small
                    color="primary"
                    @click="submit()"
                    :loading="loading"
                    elevation="0"
            >{{ isNew ? $t('msg.add') : $t('msg.save') }}</v-btn>
        </div>
    </div>
</template>

<script>
    import InputColor from "../../../ui/InputColor";
    import Tag from "@/components/ui/Tag";

    export default {
        components: {InputColor, Tag},
        data() {
            return {
                isNew: true,
                model: {
                    name: null,
                    color: null,
                    text_color: null,
                },
                loading: false,
                loadingDelete: false,
                oldName: null
            }
        },
        methods: {
            createModel() {
                this.isNew = true;
                this.model.name = null;
                this.model.color = '#A5A5A5FF';
                this.model.text_color = '#FFFFFFFF';
                this.oldName = null;
            },
            openModel(model) {
                this.isNew = false;
                this.model.name = model.name;
                this.model.color = model.color;
                this.model.text_color = model.text_color;
                this.oldName = model.name;
            },
            submit() {
                this.$validator.validateAll()
                    .then(res => {
                        if (res) {
                            this.loading = true;
                            const action = this.isNew ? 'createTag' : 'updateTag';
                            this.$store.dispatch(action, {
                                id: this.oldName,
                                data: this.model,
                                formErrors: this.$validator.errors
                            })
                                .then(res => {
                                    this.$store.commit('setTags', res);
                                    this.$emit('submitted');
                                })
                                .finally(() => this.loading = false);
                        }
                    });
            },
            deleteModel() {
                this.loadingDelete = true;
                this.$store.dispatch('deleteTag', {
                    id: this.oldName,
                })
                    .then(res => {
                        this.$store.commit('setTags', res);
                        this.$emit('submitted');
                    })
                    .finally(() => this.loadingDelete = false);
            }
        }
    }
</script>